function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { connect } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import Button from '../common/Button.react';
import Input from '../common/form/Input.react';
import Label from '../common/form/Label.react';
import SelectContactType from '../common/form/select/SelectContactType.react';
import ModalHeader from '../modal/ModalHeader.react';
var ContactsAdd = function ContactsAdd(_ref) {
  var contactsAction = _ref.contactsAction,
    hideModalAction = _ref.hideModalAction;
  var _useState = useState({
      title: '',
      contactType: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var title = form.title,
    contactType = form.contactType;
  var isValid = function isValid() {
    return title.length > 0 && contactType.length > 0;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Add Page"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, /*#__PURE__*/React.createElement(Label, {
    label: "Title",
    required: true,
    info: "Name of your contact"
  }), /*#__PURE__*/React.createElement(Input, {
    value: title,
    onChange: function onChange(e) {
      return setForm(_objectSpread(_objectSpread({}, form), {}, {
        title: e.target.value
      }));
    },
    permission: "edit-contacts"
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Contact Type",
    required: true
  }), /*#__PURE__*/React.createElement(SelectContactType, {
    value: contactType,
    onChange: function onChange(contactType) {
      return setForm(_objectSpread(_objectSpread({}, form), {}, {
        contactType: contactType
      }));
    },
    permission: "edit-contacts"
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Add",
    onClick: function onClick() {
      contactsAction({
        formData: form,
        method: 'post'
      });
      hideModalAction();
    },
    width: "120px",
    disabled: !isValid(),
    permission: "edit-contacts"
  })));
};
var mdtp = {
  contactsAction: cmsActions.contacts,
  hideModalAction: modalActions.hide
};
export default connect(null, mdtp)(ContactsAdd);